module.exports = __webpack_public_path__ + "static/img/img-card-crm-motorcycle.f137698.png";